import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  TextField,
  Modal,
  Box
} from '@mui/material';
import Layout from '../../components/layout/layout';
import SubirPolitica from '../../components/forms/Comunicados/SubirPolitica';
import { apiGet, apiPostForm } from '../../functions/api';

export default function Politicas() {
  const auth = useSelector(state => state.authUser.access_token);
  const usuario = useSelector(state => state.authUser);

  const [show, setShow] = useState(false);
  const [files, setFiles] = useState([]);
  const [filterFiles, setFilterFiles] = useState([]);
  const [filtros, setFiltros] = useState({ name: '', date: '' });

  const prop = { pathname: '/rh/politicas' };

  useEffect(() => {
    getInfo();
  }, []);

  const getInfo = async () => {
    try {
      const res = await apiGet('comunicado/politicas', auth);
      const archivos = res.data.politicas.map(file => ({
        id: file.adjuntos[0]?.id || '',
        name: file.nombre,
        date: file.Fecha_politica.slice(0, 10),
        url: file.adjuntos[0]?.url_temporal || '',
        id_comunicado: file.id
      }));
      setFiles(archivos);
      setFilterFiles(archivos);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSearch = (e) => {
    const { name, value } = e.target;
    setFiltros(prev => ({ ...prev, [name]: value }));
    const result = files.filter(file =>
      file[name].toLowerCase().includes(value.toLowerCase())
    );
    setFilterFiles(result);
  };

  const resetFilter = () => {
    setFilterFiles(files);
    setFiltros({ name: '', date: '' });
  };

  const handleView = (viewComunicado) => {
    apiPostForm('comunicado/politicas/add', viewComunicado, auth);
  };

  return (
    <Layout authUser={auth} location={prop} history={{ location: prop }} active="plataforma">
      <Box sx={{ p: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
          <Typography variant="h4">Políticas</Typography>
          <Button variant="contained" color="primary" onClick={() => setShow(true)}>
            + Nueva Política
          </Button>
        </Box>

        {/* Filtros */}
        <Grid container spacing={2} sx={{ mb: 4 }}>
          <Grid item xs={12} sm={4} md={3}>
            <TextField
              label="Fecha"
              type="date"
              name="date"
              value={filtros.date}
              onChange={handleSearch}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={3}>
            <TextField
              label="Nombre"
              name="name"
              value={filtros.name}
              onChange={handleSearch}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={4} md={3}>
            <Button onClick={resetFilter} fullWidth variant="outlined" color="secondary">
              Borrar Filtros
            </Button>
          </Grid>
        </Grid>

        {/* Grid de políticas */}
        <Grid container spacing={3}>
          {filterFiles.length > 0 ? (
            filterFiles.map((item, index) => {
              const viewComunicado = {
                id_comunicado: item.id_comunicado,
                empleado_id: usuario.user.empleado_id
              };

              return (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Card variant="outlined" sx={{ height: '100%' }}>
                    <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <Typography variant="h6" gutterBottom align="center">
                        {item.name}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" gutterBottom>
                        {item.date}
                      </Typography>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          handleView(viewComunicado);
                          window.open(item.url, '_blank');
                        }}
                        sx={{ mt: 2 }}
                      >
                        Ver 
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })
          ) : (
            <Grid item xs={12}>
              <Typography align="center" color="text.secondary">
                No hay políticas disponibles.
              </Typography>
            </Grid>
          )}
        </Grid>
      </Box>

      {/* Modal */}
      <Modal open={show} onClose={() => setShow(false)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            width: 500,
            maxHeight: '90vh',
            overflowY: 'auto',
            borderRadius: 2
          }}
        >
          <Typography variant="h6" mb={2}>
            Subir Política
          </Typography>
          <SubirPolitica getinfo={getInfo} handleClose={() => setShow(false)} />
        </Box>
      </Modal>
    </Layout>
  );
}
